import React, { PureComponent } from 'react';
import get from 'lodash/get';
import filter from 'lodash/filter';
import UIUtils from '../../../../lib/UIUtils';
import map from 'lodash/map';
import ConfigFieldValue from './ConfigFieldValue';

class EmailSourceConfiguration extends PureComponent {
  constructor(props) {
    super(props);
    this._getConditionalConfigFields = this._getConditionalConfigFields.bind(this);
  }

  _getConditionalConfigFields() {
    const { configFields, data } = this.props;
    let visibleFields = [
      {
        name: 'parameters.email',
        display_name: 'Email ID',
      },
      ...configFields,
    ];

    visibleFields = filter(
      visibleFields,
      (field) =>
        !['meta_dir', 'vendor_endpoint_id', 'start.cron'].includes(field.name) &&
        !UIUtils.shouldHideField(field, data) &&
        UIUtils.shouldRenderField(field, data),
    );

    return map(visibleFields, (field) => {
      const path_in_resource = get(field, 'path_in_resource', false);
      let value = path_in_resource
        ? get(data, path_in_resource, '')
        : get(data.script_config, field.name, '');

      value = <ConfigFieldValue field={field} value={value} />;
      if (value) {
        return (
          <div className="grid-box-item" key={field.name}>
            <div className="detail-key">{field.display_name}</div>
            <div className="detail-value">{value}</div>
          </div>
        );
      }
      return null;
    });
  }

  render() {
    return <div className="grid-box">{this._getConditionalConfigFields()}</div>;
  }
}

export default EmailSourceConfiguration;
